import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EndpointService } from '../../../../@shared/endpoints.service';
import { EventsService } from '../../../../@shared/services/events-service';
import { OrderResponse, EventResponse } from '../../../../@shared/models/response.module';

@Component({
  selector: 'app-registration-success',
  standalone: false,
  templateUrl: './registration-success.html',
  styleUrls: ['./registration-success.css']
})
export class RegistrationSuccessComponent implements OnInit {
  eventId!: number;
  sessionId: string | null = null;
  orderId: number | null = null;

  order: OrderResponse | null = null;
  event: EventResponse | null = null;

  isLoading: boolean = true;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private endpointService: EndpointService,
    private eventsService: EventsService
  ) {}

  ngOnInit(): void {
    this.eventId = Number(this.route.snapshot.paramMap.get('eventId'));
    this.sessionId = this.route.snapshot.queryParamMap.get('session_id');

    // Try to get order_id from query params or localStorage
    const orderIdParam = this.route.snapshot.queryParamMap.get('order_id');
    if (orderIdParam) {
      this.orderId = Number(orderIdParam);
    } else {
      // Try to get from localStorage (set during checkout)
      const storedOrderId = localStorage.getItem('last_order_id');
      if (storedOrderId) {
        this.orderId = Number(storedOrderId);
        localStorage.removeItem('last_order_id');
      }
    }

    this.loadData();
  }

  private loadData(): void {
    // Load event details
    this.eventsService.getEvents({ event_id: this.eventId }).subscribe({
      next: (response) => {
        if (response.data && response.data.length > 0) {
          this.event = response.data[0];
        }
      },
      error: (err) => {
        console.error('Error loading event:', err);
      }
    });

    // Load order details if we have an order ID
    if (this.orderId) {
      this.endpointService.aqh_pay_7(this.orderId).subscribe({
        next: (response) => {
          if (response.data) {
            this.order = response.data;
          }
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error loading order:', err);
          this.isLoading = false;
        }
      });
    } else {
      // No order ID, just show generic success
      this.isLoading = false;
    }
  }

  formatPrice(cents: number, currency: string): string {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }

  formatDate(dateInput: string | Date | null | undefined): string {
    if (!dateInput) return '';
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  formatDateTime(dateInput: string | Date | null | undefined): string {
    if (!dateInput) return '';
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  goToEvent(): void {
    this.router.navigate(['/event-details', this.eventId]);
  }

  goToProfile(): void {
    this.router.navigate(['/user-profile'], { queryParams: { tab: 'shows' } });
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
